module.exports = __webpack_public_path__ + "img/logo2.dd65dbb0.png";